import { render, staticRenderFns } from "./ElectronicVIT.vue?vue&type=template&id=3933b654&scoped=true"
import script from "./ElectronicVIT.vue?vue&type=script&lang=js"
export * from "./ElectronicVIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3933b654",
  null
  
)

export default component.exports